import {Component, OnInit} from '@angular/core';

declare var $: any;

@Component({
  selector: 'fx-lightbox-card',
  templateUrl: './lightbox-card.component.html',
  styleUrls: ['./lightbox-card.component.sass'],
})
export class LightboxCardComponent implements OnInit {
  files: string[] = [];
  slideIndex = 1;
  constructor() {}

  ngOnInit(): void {}

  openModal(files: any[]): void {
    this.files = files;
    this.slideIndex = 1;
    this.showSlides(this.slideIndex);
    $('#btnModalLightboxCard').trigger('click');
  }

  plusSlides(n: number): void {
    this.showSlides((this.slideIndex += n));
  }

  currentSlide(n: number): void {
    this.showSlides((this.slideIndex = n));
  }

  showSlides(n: number): void {
    setTimeout(() => {
      let i: number;
      const slides = document.getElementsByClassName('mySlides') as any;
      const captionText = document.getElementById('caption');
      if (n > slides.length) {
        this.slideIndex = 1;
      }
      if (n < 1) {
        this.slideIndex = slides.length;
      }
      for (i = 0; i < slides.length; i++) {
        slides[i].style.display = 'none';
      }
      slides[this.slideIndex - 1].style.display = 'block';
    });
  }
}
